import * as React from 'react';
import { useState } from 'react';
import { Box, List } from '@mui/material';
import { bookedeventData } from '../../data/bookevent';
import TransactionCom from '../../shared/components/student/TransactionCom';
import CustomDivider from '../../shared/utils/CustomDivider';
import { FilterDataField } from '../../shared/components/formfields/FilterDataField';
import TabsComponent from '../../shared/components/Tabs/TabComponent';
import TabPanel from '../../shared/components/Tabs/TabPanel';
import useTabs from '../../shared/hook/useTabs';



const StudentTransaction = () => {
    const [selectedDate, setSelectedDate] = useState(null);
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const { value, handleChange } = useTabs(0);
    const Content = () => {
        return (
            <>
                <Box sx={{ display: "flex", gap: 2, px: 2, my: 3 }}>
                    <FilterDataField
                        label="From"
                        onValueChange={handleDateChange}
                    />

                    <FilterDataField
                        label="To"
                        onValueChange={handleDateChange}
                    />
                </Box>

                <List>
                    {bookedeventData.map((item, index) => (
                        <>
                            <TransactionCom key={index} img={item.img} name={item.name} />
                            {index !== bookedeventData.length - 1 && (
                                <CustomDivider size={"0px"} sx={{ borderBottom: "1px solid #E8E8E8" }} />
                            )}
                        </>
                    ))}
                </List>
            </>
        )
    }

    const tabsData = [
        { label: "All", component: <Content /> },
        { label: "Courses", component: <Content /> },
        { label: "Shop", component: <Content /> },
        { label: "Events", component: <Content /> },
    ];
    return (
        <Box >

            <TabsComponent tabs={tabsData} value={value} onChange={handleChange} />
            {tabsData.map((tab, index) => (
                <TabPanel key={index} value={value} index={index}>
                    {tab.component}
                </TabPanel>
            ))}
        </Box>
    );
};

export default StudentTransaction;
